import { useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

interface MetaDescriptionProps {
  description?: string;
}

const MetaDescription: React.FC<MetaDescriptionProps> = ({ description }) => {
  const { settings } = useSiteSettings();

  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      // Use provided description, fallback to default from settings, then to hardcoded default
      const finalDescription = description || 
                              (settings.default_meta_description && settings.default_meta_description.trim()) || 
                              'Company website with job board and content management system';
      metaDescription.setAttribute('content', finalDescription);
    }
  }, [description, settings.default_meta_description]);

  return null; // This component doesn't render anything
};

export default MetaDescription;
